import React from 'react';
import './BackgroundSelector.css';

// les 4 fonds disponibles au choix pour le profil
const BACKGROUNDS = [
    { id: 1, url: '/images/backgrounds/bg1.jpg', label: 'Image 1' },
    { id: 2, url: '/images/backgrounds/bg2.jpg', label: 'Image 2' },
    { id: 3, url: '/images/backgrounds/bg3.jpg', label: 'Image 3' },
    { id: 4, url: '/images/backgrounds/bg4.jpg', label: 'Image 4' },
];

// affiche une grille de 4 fonds
// selectedUrl : l'url du fond actuellement sélectionné
// onSelect : appelé avec l'url du fond cliqué
export default function BackgroundSelector({ selectedUrl, onSelect }) {
    return (
        <div className="background-selector">
            {BACKGROUNDS.map((bg) => (
                <button
                    key={bg.id}
                    type="button"
                    className={`background-selector-item ${selectedUrl === bg.url ? 'background-selector-item--selected' : ''}`}
                    onClick={() => onSelect(bg.url)}
                >
                    <img
                        src={bg.url}
                        alt={bg.label}
                        className="background-selector-img"
                    />
                    <span className="background-selector-label">{bg.label}</span>
                </button>
            ))}
        </div>
    );
}
